import { getHeaders } from '../pages/App';
import axios, { AxiosResponse } from 'axios';
import settings from '../settings.json';
import { UserRole } from './EmployeeContext';

const settingEnv = (settings as any)[window.location.host] || settings.default;
const { api_prefix: apiPrefix } = settingEnv;

interface GetAgentLookupParams {
    role: UserRole;
    supervisor?: string;
    om?: string;
}

export interface UserDetails {
    Role: UserRole;
    Username: string;
    Email: string;
    Om?: string;
    Organization?: string;
    SeniorOm?: string;
    Site?: string;
    Supervisor?: string;
    ExpirationTimestamp: number;
}

export type EmployeePayload = UserDetails[];

export const getApiAgentLookup = async (
    lookupRole: UserRole,
    user?: string,
    userRole?: UserRole,
): Promise<AxiosResponse<EmployeePayload>> => {
    const params: GetAgentLookupParams = { role: lookupRole };

    // If the user is a Supervisor, add query param to ensure we only return direct reports
    if (userRole === UserRole.Supervisor) {
        params.supervisor = user;
    }

    const headers = await getHeaders();
    return axios.get<EmployeePayload>(`${apiPrefix}/api/agent-lookup`, {
        headers,
        params,
    });
};

/**
 * Note that now each function below can take optional user & role
 * so we can scope the results if needed.
 */
export const fetchAgents = async (
    user?: string,
    role?: UserRole,
): Promise<EmployeePayload> => {
    try {
        const agentsResponse = await getApiAgentLookup(UserRole.Agent, user, role);
        return agentsResponse.data;
    } catch (e: unknown) {
        console.error('There was a problem retrieving agent list', e);
        return [];
    }
};

export const fetchLeads = async (
    user?: string,
    role?: UserRole,
): Promise<EmployeePayload> => {
    try {
        const leadsResponse = await getApiAgentLookup(UserRole.Lead, user, role);
        return leadsResponse.data;
    } catch (e: unknown) {
        console.error('There was a problem retrieving Lead list', e);
        return [];
    }
};

export const fetchSupervisors = async (
    user?: string,
    role?: UserRole,
): Promise<EmployeePayload> => {
    try {
        const supervisorsResponse = await getApiAgentLookup(UserRole.Supervisor, user, role);
        return supervisorsResponse.data;
    } catch (e: unknown) {
        console.error('There was a problem retrieving supervisor list', e);
        return [];
    }
};

export const fetchOms = async (
    user?: string,
    role?: UserRole,
): Promise<EmployeePayload> => {
    try {
        const omsResponse = await getApiAgentLookup(UserRole.Om, user, role);
        return omsResponse.data;
    } catch (e: unknown) {
        console.error('There was a problem retrieving om list', e);
        return [];
    }
};
